module.exports = "/images/bg-auth-overlay.png?025fcdc088bd832f702ff09a382adebc";